import React from 'react';
import { IconButton } from '../../../../CommonComponents/OPL/IconButton/IconButton';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuSeparator,
  MenuTrigger,
} from '../../../../CommonComponents/OPL/Menu/Menu';
import { ListItem } from '../../../../CommonComponents/OPL/List/ListItem';

export interface Props {
  insuranceName: string;
  onEdit(): void;
  onDelete(): void;
  onClone(): void;
}

export const TableActions = ({ insuranceName, onEdit, onDelete, onClone }: Props) => {
  return (
    <td>
      <Box width="100%" display="flex" justifyContent="flex-end">
        <Menu>
          <MenuTrigger>
            <IconButton
              aria-label="Insurance menu"
              icon="far fa-ellipsis-h"
              variant="subtleInactive"
              onClick={e => e.stopPropagation()}
            />
          </MenuTrigger>

          <MenuContent align="end">
            <MenuItem onSelect={onEdit} onClick={e => e.stopPropagation()}>
              <ListItem icon="fas fa-pencil-alt">Edit</ListItem>
            </MenuItem>

            <MenuItem onSelect={onClone} onClick={e => e.stopPropagation()}>
              <ListItem icon="far fa-clone">Clone</ListItem>
            </MenuItem>

            <MenuSeparator />

            <MenuItem onSelect={onDelete} onClick={e => e.stopPropagation()}>
              <ListItem icon="far fa-trash-alt" variant="error">
                Delete
              </ListItem>
            </MenuItem>
          </MenuContent>
        </Menu>
      </Box>
    </td>
  );
};
